import { Document, Page, pdf, Text } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import { RowExportTypePdf } from "types"
import { useHandleAuth } from "utils"
import { PersonalList } from "../../types"

type UseExportPdf = {
  data: PersonalList[]
}


export const useExportPdf = ({ data }: UseExportPdf) => {
  const auth = useHandleAuth()
  const token = auth.userTokenData()

  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "ID", key: "id", width: 12 },
    { header: "NAME", key: "name", width: 16 },
    { header: "COUNTRY", key: "country", width: 14 },
    { header: "PROVINCE", key: "province", width: 14 },
    { header: "REGENCY", key: "regency", width: 14 },
    { header: "DEPARTMENT", key: "department", width: 16 },
    { header: "DIVISI", key: "divisi", width: 14 },
    { header: "BANK", key: "bank", width: 14 }
  ]

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      id: item.employee_code,
      name: item.employee_name,
      country: item.country_name,
      province: item.province_name,
      regency: item.regency_name,
      department: item.department_name,
      divisi: item.divisi_name,
      bank: item.bank_name
    }
  })

  return {
    handleExportPdf: () =>
      pdf(<PdfTemplate data={dataMap} column={columns} companyName={token?.company_name ?? ""} />)
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = "register-employee.pdf"
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  column,
  companyName
}: {
  data: RowExportTypePdf[]
  column: { header: string; key: string; width: number }[]
  companyName?: string
}) {

  return (
    <Document>
      <Page size="A4" style={{
        ...styles.page,
        paddingHorizontal: 15,
        paddingBottom: 35,
        paddingTop: 15,
      }}>
        <Text
          style={{
            fontSize: 18,
            marginTop: 30,
            textAlign: "left",
            fontWeight: "heavy",
            textTransform: "uppercase"
          }}>
          CARDS
        </Text>
        <Text
          style={{
            fontSize: 18,
            marginBottom: 8,
            textAlign: "left",
            fontWeight: "heavy",
            textTransform: "uppercase"
          }}>
          REGISTER EMPLOYEE
        </Text>

        <Text
          style={{
            fontSize: 12,
            marginBottom: 8,
            textAlign: "left",
            fontWeight: "medium"
          }}>
          {companyName?.toUpperCase() ?? ""}
        </Text>
        <TableCell data={data} column={column} />
      </Page>
    </Document>
  )
}
